const EmailChip: React.FC<{ email: string; onDelete: () => void }> = ({
  email,
  onDelete,
}) => (
  <div className="flex items-center bg-gray-200 p-2 rounded-lg mr-2">
    <span>{email}</span>
    <button onClick={onDelete} className="ml-2  font-bold">
      x
    </button>
  </div>
);

export default EmailChip;
